// Note: when adding a new variable, add it in .env.local (for development) and entrypoint.sh/AWS (for production).
const config = {
  portalUrl: '$VUE_APP_PORTAL_URL',
  portalApi: '$VUE_APP_PORTAL_API',
  hostedPaymentPageUrl: '$VUE_APP_HOSTED_PAYMENT_PAGE_URL',
  paymentGatewayApi: '$VUE_APP_PAYMENT_GATEWAY_API',
  identityApi: '$VUE_APP_IDENTITY_API'
}

export default class Configuration {
  /**
   * Get a configuration value.
   * - If we've a real value in our config, return that value (production).
   * - Otherwise try to get the value from process.env (development).
   *
   * @param {string} name
   * @return {mixed}
   */
  static get (name) {
    if (!(name in config)) {
      return
    }

    const value = config[name]

    if (!value) {
      return
    }

    if (value.startsWith('$VUE_APP_')) {
      // Value was not replaced, it seems we are in development
      // Remove $ and get current value from process.env
      const envName = value.substr(1)
      const envValue = process.env[envName]

      if (envValue) {
        return envValue
      }
    } else {
      // Value was already replaced, it seems we are in production.
      return value
    }
  }
}
